import React, { Component } from "react"
import AnchorLink from "react-anchor-link-smooth-scroll"
import { Link } from "react-router-dom"
import { throttle } from "throttle-debounce"

class PageNav extends Component {
  constructor(props) {
    super(props)
  }

  handleScroll = (sectionsPosition) => {
    let scrollPoisition =
      document.documentElement.scrollTop || document.body.scrollTop

    for (let i in sectionsPosition) {
      if (sectionsPosition[i] <= scrollPoisition) {
        let active = document.querySelector(".active-spy")
        let sectionLink = document.querySelector(
          '.page-nav__link[href*="' + i + '"]'
        )

        if (sectionLink) {
          sectionLink.classList.add("active-spy")
        }
        if (active) {
          active.classList.remove("active-spy")
        }
      }
    }
  }

  componentDidMount() {
    const sections = document.querySelectorAll(".page-section")
    let sectionsPosition = {}

    //set section positions
    sections.forEach((e) => {
      sectionsPosition[e.id] = e.offsetTop - 200
    })

    window.addEventListener(
      "scroll",
      throttle(100, () => this.handleScroll(sectionsPosition))
    )
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  render() {
    const links = [
      { name: "Why Us?", href: "#why-us" },
      { name: "Who We Serve", href: "#who-we-serve" },
      { name: "How It Works", href: "#how-it-works" },
    ]

    return (
      <nav className="page-nav">
        <ul className="page-nav__links">
          {links.map(({ name, href, active }, i) => (
            <li key={i}>
              <AnchorLink
                offset="74"
                className={`page-nav__link`}
                href={href}
                onClick={() => this.props.trackClick(name, "home-page-nav")}
              >
                {name}
              </AnchorLink>
            </li>
          ))}
          <li>
            <Link
              to={"/free-trial"}
              className="btn btn-marketing-style1 btn-outline free-trial"
              onClick={(_) =>
                this.props.trackClick("Free Trial", "home-page-nav")
              }
            >
              START FREE TRIAL
            </Link>
          </li>
        </ul>
      </nav>
    )
  }
}

export default PageNav
